module.exports = __webpack_public_path__ + "kangping/img/headimg.2fc596a1.jpg";